import { SET_CURRENT_SALON } from 'salon/constants';

const currentReducer = (state = { salon: null }, action) => {
  if (action && action.type) {
    switch (action.type) {
      case SET_CURRENT_SALON:
        return {
          ...state,
          salon: action.salon,
        };
      default:
        return state;
    }
  }
  return state;
};

export default currentReducer;
